export const DIASPARAFIRMACONTRATO = 15;
export const MAX_DIAS_PARA_FIRMA = 60;

export default { DIASPARAFIRMACONTRATO, MAX_DIAS_PARA_FIRMA };
